<script lang="ts">
	interface Props {
		count: number;
		active: number;
		onchange?: (index: number) => void;
		class?: string;
		activeColor?: 'brown' | 'white';
	}

	let { count, active, onchange, class: className, activeColor = 'brown' }: Props = $props();

	let indicators = $derived(Array.from({ length: count }).map((_, i) => i));
</script>

<div class="flex min-w-32 justify-center {className || ''}">
	<div class="flex gap-x-2">
		{#each indicators as index}
			{@const current = index === active}
			<button
				type="button"
				onclick={() => onchange?.(index)}
				aria-label={`Go to slide ${index + 1}`}
				class={[
					'h-1.5 w-1.5 rounded-full transition-all duration-300',
					{
						'opacity-100': current,
						'bg-black opacity-[0.24]': !current,
						'bg-brown-1': activeColor === 'brown' && current,
						'bg-white': activeColor === 'white' && current
					}
				]}
			></button>
		{/each}
	</div>
</div>
